import {
    FormComponentFieldAttributes,
    FormComponentFieldProps,
} from "components/Form/components/FormComponentProps";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { unsetValue } from "components/Form/components/SchemaForm/components/components";
import { SimpleToggle } from "components/Form/components/Switch/Switch";
import styles from "./Switch.module.scss";

export type SwitchProps = {
    identifier: string;
    inputProps: InputComponentProps<boolean>;
    attributes?: FormComponentFieldAttributes;
    fieldProps: FormComponentFieldProps;
};

export const TriStateSwitch = ({ identifier, inputProps, attributes, fieldProps }: SwitchProps) => {
    const isUnset = inputProps.value === unsetValue;
    const isTruthy = inputProps.value === true;
    const isFalsy = inputProps.value === false;

    const toggleInner = (
        <span className={`${isUnset ? styles.triStateUnset : styles.triStateActive}`}>
            <SimpleToggle
                additionalAttributes={{ ...attributes, ...inputProps }}
                identifier={identifier}
                size={attributes?.size}
                value={inputProps.value}
                isReadOnly={inputProps.isReadOnly}
            />
        </span>
    );

    return (
        <div className={`${styles.switch} ${styles.triStateSwitch}`}>
            <span className={`switch__label${isFalsy ? " switch__label--active" : ""}`}>false</span>
            {toggleInner}
            <span className={`switch__label${isTruthy ? " switch__label--active" : ""}`}>true</span>
        </div>
    );
};

export const TriStateCircularSwitch = ({
    inputProps,
    label,
}: Pick<SwitchProps, "inputProps"> & { label: string }) => {
    const isUnset = inputProps.value === unsetValue;
    const isTruthy = inputProps.value === true;

    const labelText = label ? label.charAt(0) : "";

    return (
        <div
            className={`${styles.triStateCircularSwitch} ${
                inputProps.isReadOnly ? styles.triStateDisabled : ""
            } ${
                isUnset
                    ? styles.triStateUnset
                    : isTruthy
                    ? styles.triStateTruthy
                    : styles.triStateFalsy
            }`}
            onClick={inputProps.onChange}
        >
            {labelText}
        </div>
    );
};
